// iter v29 r213 — Empty state riusabile con CTA.
//
// Pattern uniforme per tutte le sezioni della dashboard quando una lista
// è vuota. Visivamente: icona circle pastel + titolo + sottotitolo + 1-2 CTA.
// Allineato con lo stile della Dashboard.jsx (già ottima) e dello stile
// Pronto generale (verde sage + cream).
//
// Uso:
//   <EmptyState
//     icon={AddressBook}
//     title="Nessun contatto ancora"
//     subtitle="Importa la rubrica o aggiungi a mano."
//     primaryCta={{ label: "Aggiungi", icon: Plus, onClick: () => ... }}
//     secondaryCta={{ label: "Importa CSV", icon: Upload, onClick: () => ... }}
//   />

import React from "react";

export default function EmptyState({
  icon: Icon,
  title,
  subtitle,
  primaryCta,
  secondaryCta,
  className = "",
  testId = "empty-state",
}) {
  return (
    <div
      className={`bg-white border border-[#EAE7DF] rounded-2xl px-6 py-10 lg:px-10 lg:py-14 text-center ${className}`}
      data-testid={testId}
    >
      {Icon && (
        <div className="mx-auto w-14 h-14 rounded-full bg-[#F1F4ED] flex items-center justify-center mb-5">
          <Icon size={22} weight="duotone" className="text-[#7C8B6E]" />
        </div>
      )}
      {title && (
        <h2 className="text-[20px] sm:text-[22px] font-semibold text-[#111827] tracking-tight leading-tight">
          {title}
        </h2>
      )}
      {subtitle && (
        <p className="mt-2 text-[13.5px] text-[#6B7280] max-w-md mx-auto leading-relaxed">
          {subtitle}
        </p>
      )}
      {(primaryCta || secondaryCta) && (
        <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-2.5">
          {primaryCta && (
            <button
              type="button"
              onClick={primaryCta.onClick}
              className="inline-flex items-center gap-2 bg-[#1C1C1A] hover:bg-black text-white text-[13.5px] font-medium px-5 py-2.5 rounded-full transition-colors"
              data-testid={primaryCta.testId || `${testId}-primary-cta`}
              data-haptic="1"
            >
              {primaryCta.icon && React.createElement(primaryCta.icon, { size: 14, weight: "fill" })}
              {primaryCta.label}
            </button>
          )}
          {secondaryCta && (
            <button
              type="button"
              onClick={secondaryCta.onClick}
              className="inline-flex items-center gap-1.5 text-[13px] text-[#7C8B6E] hover:text-[#1C1C1A] font-medium px-3 py-2"
              data-testid={secondaryCta.testId || `${testId}-secondary-cta`}
            >
              {secondaryCta.icon && React.createElement(secondaryCta.icon, { size: 12, weight: "bold" })}
              {secondaryCta.label}
            </button>
          )}
        </div>
      )}
    </div>
  );
}
